module.exports = __webpack_public_path__ + "img/ruffle_length.4b069b19.png";